import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'
import ElementToggle from './ElementToggle'

export default class Toggle extends Component {
    constructor(element, options) {
        super(element, options = {
            class: 'is-toggled',
            toggler: null,
            target: null,
            isElementToggle: false,
            scrollToTarget: false,
            scrollMode: 'auto',
            scrollDelay: 250, //cas po kterym ze zacne scrollovat, kvuli spravnymu vypoctu po vsech transitionach
            hashTrigger: false
        })

        this.ref = {
            toggler: null,
            target: null
        }

        this.elementToggle = null //komponenta na togglovani vysky elementu ElementToggle.js
    }

    prepare() {
        this.toggler = this.ref.toggler
        if (!this.toggler) {
            this.toggler = this.options.toggler ? this.getElementByIdOrQuery(this.options.toggler) : this.element
        }

        this.target = this.ref.target
        if (!this.target && this.options.target) {
            this.target = this.getElementByIdOrQuery(this.options.target)
        }

        if (this.options.hashTrigger && this.target) {
            const href = this.toggler.getAttribute('href')

            if (href.startsWith('#')) {
                const targetId = href.slice(1)
                const hash = window.location.hash

                if (hash === `#${targetId}`) {
                    setTimeout(() => this.toggler.click(), 0)
                }
            }
        }

        this.toggler.addEventListener('click', this.handleTogglerClick)
    }

    destroy() {
        if (this.elementToggle) {
            this.elementToggle.destroy()
        }
    }

    handleTogglerClick = event => {
        event.preventDefault()

        this.toggler.classList.toggle('is-toggled')

        if (!this.target) {
            return
        }

        const isActive = this.target.classList.toggle(this.options.class)

        //togglovani elementu na vysku
        if (this.options.isElementToggle) {
            let elementToggle = Component.getFromElement(this.target)

            if (!elementToggle) {
                elementToggle = new ElementToggle(this.target)
                elementToggle.prepare()
            }

            elementToggle.toggle()
        }

        //moznost zascrollovat na target po pridani tridy
        if (isActive && this.options.scrollToTarget) {
            setTimeout(() => {
                scrollToElement(this.target, {mode: this.options.scrollMode})
            }, this.options.scrollDelay);
        }
    }

    getElementByIdOrQuery(value) {
        if (!value) {
            return
        }

        let element = document.getElementById(value.replace('#',''))

        if (element) {
            return element
        }

        element = this.element.querySelector(value)
        return element
    }


}
